import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

const BUSINESS_NAME = 'My Local App Business';

const TermsPage: React.FC = () => {
	return (
		<Box sx={{ py: 6 }}>
			<Container maxWidth="md">
				<Paper variant="outlined" sx={{ p: 4 }}>
					<Typography variant="h4" fontWeight={700} gutterBottom>
						Terms & Conditions
					</Typography>
					<Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
						{BUSINESS_NAME}
					</Typography>

					<Typography variant="body1" paragraph>
						Thanks for using our app. We built it to help with brewing—recipes, batches, and guidance. We’d love to hear from you: feedback and suggestions are always welcome via our contact form.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						About our AI assistant
					</Typography>
					<Typography variant="body1" paragraph>
						The assistant is powered by AI. Like any AI, it can sometimes be wrong or incomplete. We don’t guarantee its answers and we’re not responsible for decisions you make based on them. Please use your own judgment and double-check anything important.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						Payments
					</Typography>
					<Typography variant="body1" paragraph>
						We use Stripe for payments. When you pay, Stripe’s terms apply too. We’re not responsible for Stripe’s service or any payment issues on their side. Refunds and billing follow our and Stripe’s policies.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						How we provide the service
					</Typography>
					<Typography variant="body1" paragraph>
						We offer the app as is—we do our best to keep it running smoothly but can’t promise it’ll always be available or error-free. You use it at your own risk.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						If something goes wrong
					</Typography>
					<Typography variant="body1" paragraph>
						To the extent the law allows, we aren’t liable for indirect or consequential damages (like lost profits or data) from using the app, relying on AI content, or using third-party services like Stripe. If we are ever found liable, the most we’ll be responsible for is the amount you paid us in the 12 months before the issue, or $100 USD, whichever is less.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						The rest
					</Typography>
					<Typography variant="body1" paragraph>
						By using the app you’re agreeing to these terms. We may update them occasionally; if we do, continued use means you’re okay with the new version. If a court says one part doesn’t apply, the rest still does. Questions? Reach out through our contact form.
					</Typography>
				</Paper>
			</Container>
		</Box>
	);
};

export default TermsPage;
